import classNames from "../../../utils/classNames"

export const TextInputWithValue = ({
  label,
  register,
  registerName,
  disabled = false,
  type = "text",
  richText = false,
  cols = "sm:col-span-1",
  customClasses = "",
  rows = 2,
  initialValue = "",
  maxLength = 524288,
  value,
  onChange
}) => {

  return (
    <div className={cols}>
      <label className="text-sm font-medium text-gray-500">
        {label}
      </label>
      {
        richText ?
          <textarea
            {...register(registerName)}
            disabled={disabled}
            className={classNames(disabled ? "bg-gray-300" : "", `w-full mt-1 text-sm text-gray-900 border-1 border-gray-300 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 ${customClasses}`)}
            rows={rows}
            // defaultValue={initialValue}
            value={value}
            onChange={onChange}
          />
          :
          <input
            {...register(registerName)}
            disabled={disabled}
            type={type}
            className={classNames(disabled ? "bg-gray-300" : "", `w-full mt-1 text-sm text-gray-900 border-1 border-gray-300 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 ${customClasses}`)}
            // defaultValue={initialValue}
            maxLength={maxLength}
            value={value}
            onChange={onChange}
          />
      }
    </div>
  )
}